export default {
	init() {
		if (!document.querySelector("#case-study-read-more")) {
			return;
		}

		this.readMoreButton = document.querySelector("#case-study-read-more");
		this.readMoreText = document.querySelector("#read-more-text");

		// Define the click handler
		this.toggleReadMore = () => {
			if (this.readMoreText.style.height) {
				// Collapse the element
				this.readMoreText.style.height = null;
				this.readMoreText.classList.remove("active");
				this.readMoreButton.textContent = "Read More";
			} else {
				// Expand the element
				this.readMoreText.style.height = this.readMoreText.scrollHeight + "px";
				this.readMoreText.classList.add("active");
				this.readMoreButton.textContent = "Read Less";
			}
		};

		// Define the resize handler
		this.recalculateHeight = () => {
			if (this.readMoreText.classList.contains("active")) {
				this.readMoreText.style.height = this.readMoreText.scrollHeight + "px";
			}
		};

		// Attach event listeners
		this.readMoreButton.addEventListener("click", this.toggleReadMore);
		window.addEventListener("resize", this.recalculateHeight);
	},

	destroy() {
		if (this.readMoreButton && this.toggleReadMore) {
			// Remove the click event listener
			this.readMoreButton.removeEventListener("click", this.toggleReadMore);
		}

		if (this.recalculateHeight) {
			// Remove the resize event listener
			window.removeEventListener("resize", this.recalculateHeight);
		}
	},
};
